import axiosInstance from './axiosInstance'
import { TrainingPlan } from '../pages/UserTrainingPlans/TrainingPlansTable/utils'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const getAllTrainingPlans = () => {
  return axiosInstance.get(`/api/admin/trainingplan/templates`, {
    withCredentials: true,
  })
}

const getTemplate = () => {
  return axiosInstance.get(`/api/admin/trainingplan/sampletemplate`)
}

const uploadPlan = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return axiosInstance.post(`/api/v7/admin/trainingplan/upload`, formData, {
    withCredentials: true,
  })
}

const getUploadQueueStatus = () => {
  return axiosInstance.get(`/api/v7/admin/trainingplan/upload/queue/status`, {
    withCredentials: true,
  })
}

const startUploadQueue = () => {
  return axiosInstance.post(
    `/api/v7/admin/trainingplan/upload/queue/start`,
    {},
    { withCredentials: true }
  )
}

const finishUploadQueue = () => {
  return axiosInstance.post(
    `/api/v7/admin/trainingplan/upload/queue/finish`,
    {},
    { withCredentials: true }
  )
}

const notifyUploadSummary = (payload) => {
  return axiosInstance.post(
    `/api/v7/admin/trainingplan/upload/summary`,
    payload,
    { withCredentials: true }
  )
}

const getUserTrainingPlans = (userId: number) => {
  return axiosInstance.get(`/api/admin/trainingplan/users/${userId}`)
}

const updateUserTrainingPlan = (
  userId: number,
  planId: number,
  plan: TrainingPlan
) => {
  return axiosInstance.put(`/api/admin/user/${userId}/plans/${planId}`, plan)
}

const trainingplansApi = {
  getAllTrainingPlans,
  getTemplate,
  uploadPlan,
  getUploadQueueStatus,
  startUploadQueue,
  finishUploadQueue,
  notifyUploadSummary,
  getUserTrainingPlans,
  updateUserTrainingPlan,
}

export default trainingplansApi
